<template>
  <tbody :class="[showDetail ? 'isActive' : '', 'tbody']" v-if="bu">
    <tr>
      <td @click="showDetail = !showDetail" v-if="corpType == 3">
        {{ bu.corpName }}
      </td>
      <td @click="showDetail = !showDetail">
        {{ bu.startTime | moment("DD MMM") }}
      </td>
      <td @click="showDetail = !showDetail">{{ bu.src.city }}</td>
      <td @click="showDetail = !showDetail">{{ bu.dst.city }}</td>
      <td @click="showDetail = !showDetail">{{ bu.bodyType }}</td>
      <td @click="showDetail = !showDetail">{{ bu.truckTypeStr }}</td>
      <td @click="showDetail = !showDetail">{{ bu.material }}</td>
      <td @click="showDetail = !showDetail">{{ bu.dist }}</td>
      <td @click="showDetail = !showDetail">{{ bu.wishPrice }}</td>
      <td @click="showDetail = !showDetail" v-if="corpType == 2">
        {{
          !bu.loadBids || bu.loadBids.length == 0
            ? $i18n.t("No Bids")
            : bu.loadBids.length
        }}
      </td>
      <td @click="showDetail = !showDetail">
        <z-confirm-button
          class="float-right"
          color="red lighten-1"
          small
          fab
          text
          v-if="corpType == 2"
          dark
          :message="$i18n.t('Do you want to delete this load ?')"
          @click="deletebu(bu)"
        >
          <v-icon>mdi-trash-can-outline</v-icon>
        </z-confirm-button>
        <v-btn
          class="float-right"
          color="blue lighten-1"
          small
          fab
          text
          v-if="corpType == 3"
          dark
          @click="bidDialog(bu)"
          >{{ $i18n.t("Bid") }}
          <v-icon color="success lighten-1">mdi-offer</v-icon>
        </v-btn>
        <v-tooltip top v-if="false">
          <template v-slot:activator="{ on }">
            <v-btn
              class="float-right"
              color="primary"
              small
              fab
              text
              dark
              :to="'/entity/' + bu._id"
              v-on="on"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Edit</span>
        </v-tooltip>
      </td>
    </tr>

    <tr v-if="showDetail" style="background-color: #e0f2f1">
      <td colspan="14" style="text-align: -webkit-center">
        <!-- <load-add :value="bu"  colspan="14"  /> -->
        <table style="width: 100%">
          <tr v-for="(bid, index) in bu.loadBids" :key="'loadbid' + index">
            <td>{{ bid.corpName }}</td>
            <td>{{ bid.amount }}</td>
            <td>{{ bid.createdAt | moment("HH:mm DD MMM") }}</td>
            <td></td>
          </tr>
        </table>
      </td>
    </tr>

    <v-dialog
      v-model="showBidDialog"
      transition="dialog-top-transition"
      max-width="600"
    >
      <v-card>
        <v-toolbar dark color="secondary" fixed class="sticky-top">
          <v-toolbar-title>
            <v-icon>mdi-card-text</v-icon>
            {{ $i18n.t("Add/Edit Bid") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="showBidDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="4" md="4" lg="4">
              <v-text-field
                :label="$i18n.t('Amount') + '*'"
                v-model="bid.amount"
                @click.native.stop
                type="number"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <small>*indicates required field</small>
          <v-spacer></v-spacer>
          <v-btn
            color="success darken-1"
            @click="saveBid()"
            :loading="loading"
            >{{ $i18n.t("Bid") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </tbody>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import common from "@/store/common/module/common";
import { doGet, doPost } from "@/store/common/module/apis";
import LoadAdd from "@/views/load/LoadAdd";

@Component({
  name: "LoadRow",
  props: {
    value: {
      default: null,
    },
    corpType: {
      default: false,
    },
  },
  components: {
    LoadAdd,
  },
})
export default class LoadRow extends Vue {
  bu = null;
  attrs = null;
  finalFilters = {};
  payload = {};
  showDetail = false;
  showBidDialog = false;
  bid = {
    amount: null,
  };

  get loading() {
    return common.loading;
  }

  closeDialog(reload) {
    this.showCreateInvoice = false;
    if (reload) this.$emit("reload", true);
    this.showInvoiceDoanload = false;
    this.payload = {};
    this.invForMail = null;
    this.isMail = false;
  }

  async cancelTrip() {
    const data = { trip_id: this.bu._id };
    try {
      common.setLoading(true);
      await doPost("/api/trip/mark/cancelled", data);
      this.$emit("reload", true);
      common.setLoading(false);
      this.showPage(this.page);
    } catch (e) {
      common.setLoading(false);
      common.setError(e);
    }
  }

  bidDialog(load) {
    if (this.bu.loadBids && this.bu.loadBids.length > 0) {
      this.bid.amount = this.bu.loadBids[0].amount;
    }
    this.showBidDialog = true;
  }

  async saveBid() {
    try {
      common.setLoading(true);
      const response = await doPost(
        `/api/load/bid/${this.bu._id}/save`,
        this.bid
      );
      common.showMessage(`Bid Saved Successfully`);
      common.setLoading(false);
      this.showBidDialog = false;
      this.$emit("reload");
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async deletebu(bu) {
    try {
      common.setLoading(true);
      await doGet("/api/load/" + bu._id + "/delete");
      this.$emit("reload", true);
      common.showMessage("Load Deleted");
      common.setLoading(false);
    } catch (e) {
      common.setLoading(false);
      common.setError(e);
    }
  }

  mounted() {
    if (this.value) this.bu = this.value;
  }

  @Watch("selected")
  onSelectedChange(val) {
    this.trip.selected = val;
  }

  @Watch("value")
  onValueChange(val) {
    this.trip = val;
  }
}
</script>


<style scoped>
.tbody {
  height: 30px;
}
.tbody tr td {
  padding: 0 2px !important;
  cursor: pointer;
}

.tbody tr td .v-input--checkbox {
  padding: 0;
  height: 30px;
  margin-top: 8px;
}

.isActive,
.isActive:hover {
  background-color: #b2dfdb !important;
}
</style>